import { render, staticRenderFns } from "./authList.vue?vue&type=template&id=03bc6564&scoped=true"
import script from "./authList.vue?vue&type=script&lang=js"
export * from "./authList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bc6564",
  null
  
)

export default component.exports